import Button from "@mui/material/Button";
import verifytick from "../../assets/verify-tick.png";
import Navigation from "../../assets/navigetion.png";
import "./TempleDetailsView.scss";
import GoogleMap from "../../components/map/GoogleMap";
import TempleDetailsBanner from "../../components/banner/TempleDetailsBanner";
import { Box, Divider, Fab, Grid, Stack, Zoom } from "@mui/material";
import TextArea from "../../components/textarea/Textarea";
import Typography from "@mui/material/Typography";
import ImageViewer from "../../components/imageviewer/ImageViewer";
import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import { LocationOnOutlined as LocationOnOutlinedIcon } from "@mui/icons-material";
import { CallOutlined as CallOutlinedIcon } from "@mui/icons-material";
import ShareLink from "../../components/sharelink/sharelink";
import { Add as AddIcon } from "@mui/icons-material";
import { Close as CloseIcon } from "@mui/icons-material";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import { LOCALSTORAGE_KEY, templeOfferingsMenu } from "../../utils/Constants";
import {
  getTempleName,
  handleMarkerPress,
  hasAnyOfferingVisible,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import TempleOfferingsSection from "../../components/card/TempleOfferingCard/templeOfferingsSection";
import { useSelector } from "react-redux";

function TempleDetailsView(props: any) {
  const { t } = useTranslation();
  const [urlToShare, setUrlToShare] = useState<string>("");
  const [desktopButtonItem, setdDsktopButtonItem] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
    platformFeeForChadhava,
  } = priceConversionState.priceConversionRate || {};

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeName = getTempleName(props.templeDetails, savedLanguage);

  useEffect(() => {
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?templeNameKey=${props?.templeDetails?.nameKey}`
    );
  }, [props.templeDetails]);

  const [isAboveFooter, setIsAboveFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector(".footerArea");
      const button = document.querySelector(".sticky-button");
      if (footer && button) {
        const footerRect = footer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        if (
          footerRect.top < window.innerHeight &&
          footerRect.bottom >= buttonRect.bottom
        ) {
          setIsAboveFooter(true);
        } else {
          setIsAboveFooter(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const templeOpeningTime =
    props?.templePersonalInfo?.operatingHours?.period.length > 0
      ? props?.templePersonalInfo?.operatingHours?.period[0]?.openingTime
        ? props?.templePersonalInfo?.operatingHours?.period[0]?.openingTime
        : ""
      : "";
  const templeCloseingTime =
    props?.templePersonalInfo?.operatingHours?.period.length > 0
      ? props?.templePersonalInfo?.operatingHours?.period[0]?.closingTime
        ? props?.templePersonalInfo?.operatingHours?.period[0]?.closingTime
        : ""
      : "";
  const templeProfilePic = props.templeProfilePic();

  let imageArrayForTemple =
    props.templePersonalInfo &&
    props.templePersonalInfo.media &&
    props.templePersonalInfo.media.pictures &&
    props.templePersonalInfo.media.pictures.length
      ? props.templePersonalInfo.media.pictures
      : [];

  useEffect(() => {
    if (props?.templeDetails) {
      const templeDetails = props?.templeDetails;

      const _desktopButtonItem = [
        !templeDetails?.isClosedBooking && (
          <Button onClick={() => props.goToBookPujaScreen()}></Button>
        ),
        templeDetails?.isPrasadEnabled && (
          <Button onClick={() => props.goToBookPrasadScreen()}></Button>
        ),
        templeDetails?.isChadhavaEnabled && (
          <Button onClick={() => props.goToBookChadhavaScreen()}></Button>
        ),
      ].filter(Boolean);
      setdDsktopButtonItem(_desktopButtonItem);
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [props?.templeDetails]);



  return (
    <>
      {isLoading ? (
        <Box className="pageContainer templeDetailsPage">
          <Box className="templeDetailsBlock">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  md={2}
                  lg={3}
                  xl={3}
                  className="templeLeftDetailsBlock"
                ></Grid>
                <Grid item xs={12} md={8} lg={6} xl={6}>
                  <Box className="loader">
                    <CircularProgress />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className="pageContainer templeDetailsPage">
          <Box className="templeDetailsBlock">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  md={2}
                  lg={2}
                  xl={2}
                  className="templeLeftDetailsBlock"
                >
                  {/* <LeftAddressCard
                header="Current Address"
                address="198/3, 3 Cross 80 Feet Road, Next.."
                footerButton="Edit or add an address"
              /> */}
                </Grid>
                <Grid item xs={12} md={8} lg={8} xl={8}>
                  <Box className="templeDetailsCenterBlock" data-scroll-id={"temple-details-banner"}>
                    <TempleDetailsBanner
                      templeProfilePic={templeProfilePic}
                      templeMediaList={imageArrayForTemple}
                    />
                    <Box className="shareIcon">
                      <ShareLink urlToShare={urlToShare} type="Temple Details"></ShareLink>
                    </Box>
                    <Box className="ganpatiTempleDetails">
                      <Typography className="templeDetailsTitle">
                        {templeName}
                        <ImageViewer pictureUrl={verifytick} alt={templeName} />
                      </Typography>
                      <Box className="ratings">
                        <StarOutlinedIcon />
                        <Typography>
                          <span>
                            {props?.templeDetails?.googleData?.rating}
                          </span>{" "}
                          <span className="ratingCount">
                            (
                            {
                              props?.templeDetails?.googleData
                                ?.user_ratings_total
                            }
                            + ratings)
                          </span>
                        </Typography>
                      </Box>
                      {hasAnyOfferingVisible(templeOfferingsMenu, props.templeDetails) && (
                      <>
                        <Typography className="offeringsHeading">
                          {t(LOCALIZATION.Offerings_Available_In_This_Temple)}
                        </Typography>

                        <Box className="offeringsRow" data-scroll-id={"temple-offerings-menu"}>
                          {templeOfferingsMenu.map((item: any) => {
                          let isVisible = false;
                          if (item.type === "puja") {
                            const isClosedBooking = props.templeDetails?.isClosedBooking ?? true;
                            const templePujaList = props.templeDetails?.templePuja || [];
                            const hasActivePuja = templePujaList.some(
                              (puja: any) => puja?.isPujaDisable === false
                            );
                            isVisible = !isClosedBooking && hasActivePuja;
                            } else if (item.type === "chadhava") {
                              isVisible =
                                props.templeDetails?.isChadhavaEnabled ?? false;
                            } else if (item.type === "prasad") {
                              isVisible =
                                props.templeDetails?.isPrasadEnabled ?? false;
                            }
                            if (!isVisible) return null;

                            const indiaFinalPrice =
                              props.templeDetails?.minPrices?.[item?.type]
                                ?.india?.finalPrice ?? 0;

                            const indiaStrikePrice =
                              props.templeDetails?.minPrices?.[item?.type]
                                ?.india?.offerActualPrice ?? 0;

                            const overseasFinalPrice =
                              props.templeDetails?.minPrices?.[item?.type]
                                ?.overseas?.finalPrice ?? 0;

                            const overseasStrikePrice =
                              props.templeDetails?.minPrices?.[item.type]
                                ?.overseas?.offerActualPrice ?? 0;

                            const finalPrice = isOverseas
                              ? truncateToTwoDecimals(overseasFinalPrice * rate)
                              : indiaFinalPrice;

                            const strikePrice = isOverseas
                              ? truncateToTwoDecimals(
                                  overseasStrikePrice * rate
                                )
                              : indiaStrikePrice;

                            return (
                              <TempleOfferingsSection
                                key={item?.id}
                                title={item?.title}
                                description={item?.description}
                                icon={item?.icon}
                                type={item?.type}
                                buttonText={item?.buttonText}
                                currencySymbols={currencySymbols}
                                finalPrice={finalPrice}
                                strikePrice={strikePrice}
                                templeDetails={props.templeDetails}
                                onClick={(type: any) => {
                                  if (type === "puja")
                                    props.goToBookPujaScreen();
                                  if (type === "chadhava")
                                    props.goToBookChadhavaScreen();
                                  if (type === "prasad")
                                    props.goToBookPrasadScreen();
                                }}
                              />
                            );
                          })}
                        </Box>
                      </>
                      )}
                      <Divider className="divider-temple" />

                      <Box className="templeDetailsContent" data-scroll-id={"temple-details-content"}>
                        <Box className="aboutTemple">
                          <TextArea
                            title={
                              props.templePersonalInfo.descriptions
                                ? props.templePersonalInfo.descriptions
                                : ""
                            }
                            elevation={0}
                          ></TextArea>
                        </Box>
                        <Box className="addressTemple">
                          <Box>
                            <LocationOnOutlinedIcon
                              sx={{ fontSize: 20, opacity: 0.5 }}
                            />
                          </Box>
                          <Box>
                            <TextArea
                              title={
                                props.templePersonalInfo.address &&
                                props.templePersonalInfo.address
                                  .formatted_address
                                  ? `${props?.templePersonalInfo?.name} ${props?.templePersonalInfo?.address.formatted_address}`
                                  : ""
                              }
                              elevation={0}
                            ></TextArea>
                          </Box>
                        </Box>
                        <Box className="openingPujaTime">
                          <Box className="openingTime">
                            <Box>
                              <AccessTimeIcon
                                sx={{ fontSize: 20, opacity: 0.5 }}
                              />
                            </Box>
                            <Box>
                              <TextArea
                                title={`${t(
                                  LOCALIZATION.Open
                                )} - ${templeOpeningTime}`}
                                elevation={0}
                              ></TextArea>
                              <TextArea
                                title={`${t(
                                  LOCALIZATION.Close
                                )} - ${templeCloseingTime}`}
                                elevation={0}
                              ></TextArea>
                            </Box>
                          </Box>
                        </Box>
                        <Box className="phnTemple">
                          <Box>
                            <CallOutlinedIcon
                              sx={{ fontSize: 20, opacity: 0.5 }}
                            />
                          </Box>
                          <Box>
                            <TextArea
                              title={props.templePersonalInfo.phoneNumber}
                              elevation={0}
                            ></TextArea>
                          </Box>
                        </Box>

                        {props?.templeDetails?.isClosed === true && (
                          <Box>
                            <Typography
                              sx={{
                                color: "red",
                                fontSize: 20,
                                paddingTop: "0.5rem",
                              }}
                            >
                              {t(LOCALIZATION.Temple_is_closed)}
                            </Typography>
                          </Box>
                        )}
                        <Box className="googleMap">
                          <GoogleMap personalInfo={props.templePersonalInfo} />
                        </Box>
                      </Box>

                      <Box sx={{ mt: 2 }}>
                        <Button
                          onClick={() => {
                            handleMarkerPress(
                              props?.templeDetails?.personalInfo?.address
                                ?.coordinates?.latitude,
                              props?.templeDetails?.personalInfo?.address
                                ?.coordinates?.longitude
                            );
                          }}
                        >
                          <ImageViewer
                            pictureUrl={Navigation}
                            alt={templeName}
                          />
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2}
                  lg={2}
                  xl={2}
                  className="templeRightDetailsBlock"
                >
                  {/* <RightBlockCard /> */}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}

export default TempleDetailsView;
